const t = {
  name: "Edited",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.1213 2.70705C17.9497 1.53548 16.0503 1.53547 14.8787 2.70705L2 15.5857V21.9999H8.41421L21.2929 9.12126C22.4645 7.94969 22.4645 6.0502 21.2929 4.87862L19.1213 2.70705ZM16.2929 4.12126C16.6834 3.73074 17.3166 3.73074 17.7071 4.12126L19.8787 6.29284C20.2692 6.68336 20.2692 7.31652 19.8787 7.70705L18.4999 9.08579L14.9142 5.5L16.2929 4.12126ZM13.4999 6.91422L17.0857 10.5L7.58579 19.9999H4V16.4142L13.4999 6.91422Z" fill="currentColor"/>
<path d="M5 3.99994C4.44772 3.99994 4 4.44765 4 4.99994V8.99994H2V4.99994C2 3.34308 3.34315 1.99994 5 1.99994H9V3.99994H5Z" fill="currentColor"/>
<path d="M20 18.9999C20 19.5522 19.5523 19.9999 19 19.9999H15V21.9999H19C20.6569 21.9999 22 20.6568 22 18.9999V14.9999H20V18.9999Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Edited
};
